import React, { Component } from 'react'
import CancelBet from '../appComponents/betting/betStages/CancelBet'
import SubmitVote from '../appComponents/betting/betStages/SubmitVote'
import SubmitSecondVote from '../appComponents/betting/betStages/SubmitSecondVote'
import GetPaid from '../appComponents/betting/betStages/GetPaid'
import Countdown from 'react-countdown-now';
import { List, Icon, Menu, Dropdown, Tooltip } from 'antd';
import { FacebookShareButton, TwitterShareButton, EmailShareButton, TelegramShareButton, WhatsappShareButton } from 'react-share'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaTelegram, FaWhatsapp, FaUserSecret } from 'react-icons/fa';
const betCopy = "Take the other side of the bet I just made on mevu.bet!";

export default class MyBetStage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            componentToReturn: <Icon type="loading" />
        }
    }

    componentDidMount() {
        this.setState({ componentToReturn: this.renderStage(this.props.status, this.props.wager, this.props.makerTaker) });
    }

    renderStage(status, wager, makerTaker) {
        // let { startTimeNumber, duration } = this.props;
        let component = [];
        // console.log("rendering stage of wager " + JSON.stringify(wager));
        // console.log("TAKER " + wager.taker);
        // if (wager.settled) {
        //     return <div>Settled</div>
        // } else if (wager.cancelled) {
        //     return <div>Cancelled</div>
        // } else if (wager.taker == "" && Date.now() / 1000 > startTimeNumber + duration) {
        //     return <div className="my-bets-page-cards-wagers-wager-odds">Event is over and nobody took wager, click to cancel</div>
        // } else if (wager.taker == "" && Date.now() / 1000 < startTimeNumber + duration) {
        //     return <div className="my-bets-page-cards-wagers-wager-odds">Waiting for taker</div>
        // } else if (wager.taker != "" && Date.now() / 1000 < startTimeNumber + duration) {
        //     return <div className="my-bets-page-cards-wagers-wager-odds">Waiting for event to finish</div>
        // } else {
        //     return null
        // }

        const menu = (
            <Menu theme={"dark"} style={{ width: "50px" }}>
                <Menu.Item>
                    <FacebookShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="facebook" />} quote={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <TwitterShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="twitter" />} title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <TelegramShareButton children={

                        <FaTelegram style={{ fontSize: "26px", color: 'white' }} />
                    }
                        title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <WhatsappShareButton children={

                        <FaWhatsapp style={{ fontSize: "26px", color: 'white' }} />
                    }
                        title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
                <Menu.Item>
                    <EmailShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="mail" />} subject={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                </Menu.Item>
            </Menu>
        );


        if (status == "untaken-pregame") {
            if (wager.isPrivate) {
                component.push(<div>PRIVATE <FaUserSecret /></div>);
            } else {
                component.push(<div>PUBLIC <Icon type="notification" /></div>);
            }
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for match <Dropdown overlay={menu}>
                <a className="ant-dropdown-link" href="#">
                    <Icon style={{ fontSize: "26px" }} type="share-alt" />
                </a>
            </Dropdown></div>);           
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <CancelBet bet={wager} />
                </div>
            </div>);
        } else if (status == "taken-pregame") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for event </div>);
        } else if (status == "untaken-postgame") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Never found a match</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <CancelBet bet={wager} />
                </div>
            </div>);
        } else if (status == "novotes-postgameprefinalized") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <SubmitVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                </div>
            </div>);
        } else if (status == "novotes-postgamepostfinalized") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won click for payout.</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options">
                <div className="my-bets-page-cards-wagers-wager-options-cancel">
                    <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                </div>
            </div>);
        } else if (status == "onlymakervoted-preeventfinalized") {
            if (makerTaker == "maker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitSecondVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }
        }
        else if (status == "onlymakervoted-posteventfinalized") {
            if (makerTaker == "maker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won click for payout.</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won submit vote to initiate payout.</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitSecondVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }
        } else if (status == "onlytakervoted-preeventfinalized") {
            if (makerTaker == "taker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Waiting for opponent to submit their vote</div>);
            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitSecondVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }


        } else if (status == "onlytakervoted-posteventfinalized") {
            if (makerTaker == "taker") {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Event has been finalized, if you won click for payout.</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            } else {
                component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">Submit the winner</div>);
                component.push(<div className="my-bets-page-cards-wagers-wager-options">
                    <div className="my-bets-page-cards-wagers-wager-options-cancel">
                        <SubmitVote bet={wager} event={this.props.event} propEvent={this.props.propEvent} />
                    </div>
                </div>);

            }


        } else if (status === "settled-nodispute" || status === "settled") {
            let takerWon = false;
            let makerWon = false;
            let noWinner = false;
            console.log("wager.maker - " + wager);
            //console.log("wager.winner - " + wager.winner);
            if (wager.maker == wager.winner) {
                makerWon = true;
            } else if (wager.taker == wager.winner) {
                takerWon = true;
            } else if (wager.taker != wager.winner && wager.maker != wager.winner) {
                noWinner = true;
            }
            if (makerTaker === "taker") {
                if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            } else {
                if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">  <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            }
        } else if (status === "dispute-settlednotpaid") {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">  <GetPaid bet={wager} event={this.props.event} propEvent={this.props.propEvent} /></div>);
        } else if (status === "dispute-settledpaid") {
            let takerWon = false;
            let makerWon = false;
            let noWinner = false;
            console.log("wager.maker - " + wager);
            //console.log("wager.winner - " + wager.winner);
            if (wager.maker == wager.winner) {
                makerWon = true;
            } else if (wager.taker == wager.winner) {
                takerWon = true;
            } else if (wager.taker != wager.winner && wager.maker != wager.winner) {
                noWinner = true;
            }
            if (makerTaker === "taker") {
                if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">
                        <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            } else {
                if (makerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">  <span style={{ color: '#27f727' }}>YOU WON</span></div>);
                } else if (takerWon) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(245, 60, 64)' }}>YOU LOST</span></div>);
                } else if (noWinner) {
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">SETTLED BY ORACLES</div>);
                    component.push(<div className="my-bets-page-cards-wagers-wager-options-stage"><span style={{ color: 'rgb(209, 174, 94)' }}>NO WINNER COULD BE DECIDED, YOU WERE REFUNDED</span></div>);

                }
            }


        } else {
            component.push(<div className="my-bets-page-cards-wagers-wager-options-stage">{status}</div>);
        }
        return component;
    }

    render() {
        return (
            <div>
                {this.state.componentToReturn}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/MyBetStage.js